import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { TableControlIcon } from '../../../Table'
import { getIsRentalPortalViewRegimeOptionInert } from '../RentalPortalViewRegimeControl.utils'

import * as styles from './RentalPortalViewRegimeControlOption.module.css'

function RentalPortalViewRegimeControlOption({
  listViewType,
  option,
  onChange,
  onKeyDown,
}) {
  const { t } = useTranslation()

  function handleClick() {
    onChange(option.value)
  }

  return (
    <TableControlIcon
      Icon={option.Icon}
      className={classNames({ [styles.active]: option.isActive })}
      disabled={getIsRentalPortalViewRegimeOptionInert({
        listViewType,
        option,
      })}
      qaName={option.name}
      tooltip={t(option.label)}
      onClick={handleClick}
      onKeyDown={onKeyDown}
    />
  )
}

export default RentalPortalViewRegimeControlOption
